import axios from 'axios';
import ProductPost from '@/interfaces/ProductPostInterface';
import { env } from '@/helpers';

class ProductAPI {
  static get(id: number): Promise<ProductPost | undefined> {
    return new Promise((resolve, reject) => {
      axios.get<ProductPost | undefined>(`${env('API_BASE_PATH')}products`, {
        params: {
          id,
        },
      }).then((response) => {
        resolve(response.data || undefined);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default ProductAPI;
